import { gql } from "graphql-request";

export const POP_MOVIES_QUERY = gql`
    query {
        movieQuery {
            getPopularMovies {
                __typename
                mainVersionId
                premiere
                title
                isKinoklubb
                genres
                lengthInMinutes
                rating
                sanityIdArt
                sanityImagePosterUrl
                sanityImageWideUrl
                nffMovieId
              }
        }
    }
`;